/* eslint-disable react-hooks/exhaustive-deps */
import React, { HTMLProps, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import moment from 'moment';
import { FiDownload } from 'react-icons/fi';
import { IAppState } from 'src/store';
import './styles.scss';
import DepositionItemListFileName from './DepositionItemListFileName';
import { FileData } from 'src/dataFactory/depositionFactory';
import { PATHS } from 'src/appConfig/paths';
import { ErrorService, Navigator } from 'src/services';
import { depositionAction } from 'src/redux/depositionRedux';
import { Button, Text, View } from 'src/components/common';
import { FilePreDownloadPayload } from 'src/redux/fileRedux/types';
import { filesAction } from 'src/redux/fileRedux';

const DepositionItem: React.FC<Props> = ({
  deposition,
  className,
  onGetResources,
  onSetDepositionFinal,
  onDownloadFiles,
  ...props
}) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    onGetResources({ uri: deposition.subResources.finalDepositionFilesUri }, getFilesSuccess, getFilesError);
  }, [deposition]);

  const [finalFiles, setFinalFiles] = useState<FileData[]>([]);

  const getFilesSuccess = (res: FileData[]) => {
    setFinalFiles(res ?? []);
  };

  const getFilesError = (err: any) => {
    ErrorService.handler(err);
  };

  const navigateToDetails = async () => {
    Navigator.navigate(`${PATHS.RepositoryManagement}/${deposition.id}`);
  };

  const handleDownloadFiles = (e: any) => {
    e.stopPropagation();

    setIsLoading(false);
    const downloadFiles: FilePreDownloadPayload[] = finalFiles.map(file => ({
      downloadUri: file.downloadUri,
      fileName: `${file.name}.${file.extension}`,
    }));
    onDownloadFiles(downloadFiles);
    setIsLoading(false);
  };

  return (
    <View onClick={navigateToDetails} className={cn('cmp-deposition-item', className)} {...props}>
      <View className="cmp-deposition-item__title-container ">
        <Text className="cmp-deposition-item__title" size={20}>
          {deposition.caseId} - {deposition.name}
        </Text>
        <Text size={14} className="cmp-deposition-item__upload-date mb-16">
          Opened on {moment(deposition.openDate).format('DD MMM, YYYY')}
        </Text>
        <View isRow className="cmp-deposition-item__list-container">
          <DepositionItemListFileName title={'Final Deposition Files'} type="final" files={finalFiles} />
          <Button
            icon={<FiDownload />}
            label="Download All"
            onClick={handleDownloadFiles}
            variant="secondary"
            className="cmp-deposition-item__download-button"
            disabled={finalFiles.length === 0 || isLoading}
          />
        </View>
      </View>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  HTMLProps<HTMLDivElement> & {
    deposition: any;
  };

const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {
  onGetResources: depositionAction.getDepositionFinalFiles,
  onSetDepositionFinal: depositionAction.setDepositionFinal,
  onDownloadFiles: filesAction.downloadFiles,
};

export default connect(mapStateToProps, mapDispatchToProps)(DepositionItem);
